import axios from "axios";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { displayDate } from "../utils/utils";
import TreePointCloud from "./TreePointCloud";
import { serverURL } from "./networking";

export default function Report({ report, plotId }) {
    const [data, setData] = useState([]);
    const [valid, setValid] = useState(true);
    const [receivedResponse, setReceivedResponse] = useState(false);
    const [trees, setTrees] = useState([]);
    const [latValue, setLatValue] = useState("0.000000");
    const [lonValue, setLonValue] = useState("0.000000");

    const latValueChange = (event) => {
        setLatValue(event.target.value);
    };
    const lonValueChange = (event) => {
        setLonValue(event.target.value);
    };
    const [errorMessage, setErrorMessage] = useState("");

    const serverUpdateCoords = () => {
        axios
            .post(
                serverURL + "/api/plot/update-coords/",
                {
                    plot_id: plotId,
                    latitude: latValue,
                    longitude: lonValue,
                },
                {
                    withCredentials: true,
                    headers: {
                        "X-CSRFToken": csrf,
                    },
                },
            )
            .then(function (response) {
                console.log(response);
                window.location.reload();
            })
            .catch(function (error) {
                setErrorMessage(error.response.data.message);
                console.log(error);
            });
    };

    let csrf = document.cookie.replace(
        /(?:(?:^|.*;\s*)csrftoken\s*\=\s*([^;]*).*$)|^.*$/,
        "$1",
    );
    useEffect(() => {
        axios
            .get(serverURL + "/api/plot/", {
                withCredentials: true,
                headers: {
                    "X-CSRFToken": csrf,
                },
                params: {
                    plot_id: plotId,
                },
            })
            .then(function (response) {
                setReceivedResponse(true);
                console.log(response.data);
                setData(response.data.plot);
                if (response.data.plot.trees) {
                    setTrees(
                        response.data.plot.trees.sort(
                            (a, b) => a.tree_number - b.tree_number,
                        ),
                    );
                } else {
                    setTrees([]);
                }
                setLatValue(response.data.plot.center_latitude.toFixed(6));
                setLonValue(response.data.plot.center_longitude.toFixed(6));
            })
            .catch(function (error) {
                setReceivedResponse(true);
                console.log(error);
                setValid(false);
            });
    }, []);

    function getCSV(plotId) {
        axios({
            url: serverURL + "/api/csv/",
            method: "GET",
            headers: {
                "X-CSRFToken": csrf,
            },
            withCredentials: true,
            responseType: "blob",
            params: {
                plot_id: plotId,
            },
        })
            .then((response) => {
                const url = window.URL.createObjectURL(
                    new Blob([response.data]),
                );
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "trees_data.csv");
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            })
            .catch((error) => {
                console.error(
                    "There was an error downloading the file:",
                    error,
                );
            });
    }

    function displayDirection(tree) {
        var vertical = tree.y > 0 ? "m N, " : "m S, ";
        var horizontal = tree.x > 0 ? "m E" : "m W";

        return (
            Math.abs(tree.y.toFixed(3)) +
            vertical +
            Math.abs(tree.x.toFixed(3)) +
            horizontal
        );
    }
    function displayDisplacement(tree) {
        return Math.sqrt(Math.pow(tree.x, 2) + Math.pow(tree.y, 2)).toFixed(2);
    }
    function displayHeading(tree) {
        if (tree.y > 0) {
            return (
                (360 + (180 / Math.PI) * Math.atan(tree.x / tree.y)) %
                360
            ).toFixed(0);
        } else {
            return (
                180.0 +
                (180 / Math.PI) * Math.atan(tree.x / tree.y)
            ).toFixed(0);
        }
    }

    return (
        <div>
            <h1 className="section-title">
                Plot Data <br /> Plot: {report}
            </h1>

            <Link href={{ pathname: "reports" }}>Return to Plot List</Link>
            {receivedResponse ? (
                valid ? (
                    <div>
                        <h3 onClick={() => getCSV(plotId)}>Download .CSV</h3>
                        <h4>
                            Collected at:
                            <br />
                            Latitude:{""}
                            <input
                                type="text"
                                value={latValue}
                                onChange={latValueChange}
                                placeholder="Enter Coordinates Here"
                            />
                            <br />
                            Longitude:{"  "}
                            <input
                                type="text"
                                value={lonValue}
                                onChange={lonValueChange}
                                placeholder="Enter Coordinates Here"
                            />
                            <br />
                            <button onClick={serverUpdateCoords}>
                                Update Coordinates
                            </button>
                            <br />
                            <p>{errorMessage}</p>
                            <br />
                            Collected on: {displayDate(data.date_collected)}
                            <br />
                            {data.notes ? "Notes: " + data.notes : <></>}
                        </h4>
                        <ul>
                            {trees.length < 1 ? (
                                <p>No trees found in this plot!</p>
                            ) : (
                                trees.map((tree) => (
                                    <li
                                        key={tree.tree_id}
                                        className="report-list-option"
                                    >
                                        <div className="plot-main-info">
                                            <h4>Tree #{tree.tree_number}</h4>
                                            <ul>
                                                {tree.height ? (
                                                    <li>
                                                        Tree Height:{" "}
                                                        {tree.height.toFixed(
                                                            2,
                                                        ) + " m"}
                                                    </li>
                                                ) : (
                                                    <></>
                                                )}
                                                {tree.dbh ? (
                                                    <li>
                                                        Tree Diameter:{" "}
                                                        {(
                                                            Math.round(
                                                                tree.dbh *
                                                                    10000,
                                                            ) / 10000
                                                        ).toFixed(1) + " cm"}
                                                    </li>
                                                ) : (
                                                    <></>
                                                )}
                                                <li>
                                                    Tree Species:{" "}
                                                    {tree.species
                                                        ?.scientific_name ??
                                                        "No data"}
                                                </li>
                                                <li>
                                                    Tree Genus:{" "}
                                                    {tree.genus
                                                        ?.scientific_name ??
                                                        "No data"}
                                                </li>
                                                <li>
                                                    Tree Biomass:{" "}
                                                    {tree.biomass + " kg" ??
                                                        "No data"}
                                                </li>
                                                {tree.latitude &&
                                                tree.longitude ? (
                                                    <li>
                                                        Tree Location:{" "}
                                                        {tree.latitude.toFixed(
                                                            6,
                                                        ) +
                                                            "°, " +
                                                            tree.longitude.toFixed(
                                                                6,
                                                            ) +
                                                            "°"}
                                                    </li>
                                                ) : (
                                                    <></>
                                                )}
                                                {tree.x && tree.y ? (
                                                    <li>
                                                        Location relative to
                                                        plot center:{" "}
                                                        {displayDirection(tree)}
                                                    </li>
                                                ) : (
                                                    <></>
                                                )}
                                                {
                                                    <li>
                                                        Distance from Plot
                                                        Center:{" "}
                                                        {displayDisplacement(
                                                            tree,
                                                        )}
                                                        m
                                                    </li>
                                                }
                                                {
                                                    <li>
                                                        Direction from Plot
                                                        Center:{" "}
                                                        {displayHeading(tree)}°
                                                    </li>
                                                }

                                                <li>
                                                    Decay Level: {tree.decay}%
                                                </li>

                                                {tree.notes && (
                                                    <li>Notes: {tree.notes}</li>
                                                )}

                                                {tree.photo_paths &&
                                                    tree.photo_paths.map(
                                                        (url) => (
                                                            <li>
                                                                <img
                                                                    src={url}
                                                                    alt=""
                                                                    width="200"
                                                                ></img>
                                                            </li>
                                                        ),
                                                    )}
                                                <li>{tree.point_cloud}</li>
                                                {tree.point_cloud && (
                                                    <TreePointCloud
                                                        url={tree.point_cloud}
                                                    />
                                                )}
                                            </ul>
                                        </div>
                                    </li>
                                ))
                            )}
                        </ul>
                    </div>
                ) : (
                    <h4>Invalid Report</h4>
                )
            ) : (
                <h4> Loading </h4>
            )}
        </div>
    );
}
